export enum EDeviceType {
  VIDEO_INPUT = 'videoinput',
  AUDIO_INPUT = 'audioinput',
  AUDIO_OUTPUT = 'audiooutput',
}

export interface IDevices {
  videoInputs: MediaDeviceInfo[];
  audioInputs: MediaDeviceInfo[];
  audioOutputs: MediaDeviceInfo[];
}
